var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
		{
			'builder-element': !_vm.onPreview,
			'hide-desktop': _vm.node.options.visible_desktop,
			'hide-mobile': _vm.node.options.visible_mobile,
		},
		_vm.node.class ],attrs:{"id":_vm.node.id,"data-key":_vm.node.key,"data-elIcon":_vm.node.icon,"data-elName":_vm.node.name,"data-type":_vm.node.type},on:{"click":function($event){return _vm.onNodeClick(_vm.node)}}},[(!_vm.onPreview)?_c('NodeAction',{attrs:{"node":_vm.node,"component":"element"}}):_vm._e(),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"node-anchor"},[_c('i',{staticClass:"material-icons"},[_vm._v("anchor")])])}]

export { render, staticRenderFns }